import { useFloors } from '@services/common'
import { useTranslation } from 'react-i18next'

import { Label } from '@/components/ui/label'
import { MultiCombobox } from '@/components/ui/multi-combobox'

interface Props {
  value?: string[]
  onChange: (value: string[]) => void
  disabled?: boolean
}

export function FloorSelect({ value = [], onChange, disabled }: Props) {
  const { t } = useTranslation('application')
  const floors = useFloors()

  const options = (floors.data ?? [])
    .filter((floor) => floor.id)
    .map((floor) => ({ value: floor.id!, label: floor.name ?? '' }))

  return (
    <div>
      <Label className="mb-1.5 block">{t('form.sections.housing.floor')}</Label>
      <MultiCombobox
        value={value}
        onChange={onChange}
        options={options}
        disabled={disabled}
        placeholder={t('form.common.selectFloor')}
      />
    </div>
  )
}
